import { css } from '@emotion/react';
export const containerNotice = css `
  display: flex !important;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: center;
  background-color: #f7f7f7;
  font-family: RakutenSansUi, sans-serif;
  padding: 48px 24px;
  box-shadow: 0px -1px 0px #d1d1d1;
  @media (max-width: 48em) {
    flex-direction: column;
    align-items: stretch;
  }
  @media (max-width: 36em) {
    padding: 16px;
  }
`;
export const containerTxt = css `
  max-width: 1084px;
  display: flex !important;
  flex-direction: column;
  margin-right: 64px;
  @media (max-width: 93.25em) {
    margin-right: 32px;
  }
  @media (max-width: 75em) {
    margin-right: 24px;
  }
  @media (max-width: 62em) {
    margin-right: 24px;
  }
  @media (max-width: 48em) {
    margin-right: 0;
  }
`;
export const titleTxtStyle = css `
  font-size: 16px !important;
  font-weight: bold !important;
  color: #333333 !important;
  line-height: 20px !important;
  margin-bottom: 16px;
  @media (max-width: 36em) {
    margin-bottom: 8px;
    font-size: 14px;
    line-height: 18px;
  }
`;
export const containerContinueWithoutConsent = css `
  display: flex !important;
  cursor: pointer;
  margin-bottom: 16px;
  @media (max-width: 36em) {
    margin-bottom: 8px;
  }
`;
export const continueWithoutConsentTxtStyle = css `
  color: black !important;
  font-size: 14px !important;
  line-height: 18px !important;
  margin-right: 10px;
`;
export const containerArrow = css `
  display: flex !important;
  align-items: center;
`;
export const paragraphTxtStyle = css `
  color: #4d4d4d !important;
  font-size: 14px !important;
  line-height: 18px !important;
  margin-bottom: 0px !important;
  .vender-list {
    text-decoration: underline;
    cursor: pointer;
  }
  @media (max-width: 48em) {
    margin-bottom: 16px !important;
  }
  @media (max-width: 36em) {
    font-size: 12px !important;
    line-height: 15px !important;
  }
`;
export const lnkDidomi = css `
  text-decoration-line: underline !important;
  cursor: pointer !important;
`;
export const containerBtn = css `
  display: flex !important;
  flex-direction: column;
`;
export const didomi_accept_button = css `
  display: flex !important;
  height: 48px;
  width: 194px;
  justify-content: center;
  align-items: center;
  font-size: 14px !important;
  font-weight: bold !important;
  line-height: 24px !important;
  text-transform: uppercase;
  border-radius: 4px;
  cursor: pointer;
  color: white;
  background-color: #bf0000;
  margin-bottom: 16px;
  @media (max-width: 48em) {
    width: 100%;
  }
`;
export const preferencesBtn = css `
  display: flex !important;
  height: 48px;
  width: 194px;
  justify-content: center;
  align-items: center;
  font-size: 14px !important;
  font-weight: bold !important;
  line-height: 24px !important;
  text-transform: uppercase;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #bf0000;
  color: #bf0000;
  background-color: #f7f7f7;
  @media (max-width: 48em) {
    width: 100%;
  }
`;
